import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';

interface MemberAdvancedSearchBoxWithTitleProps {
  title: string;
  children: React.ReactNode;
  noGrid?: boolean; // Optional prop to make Grid wrapper optional
}

export const MemberAdvancedSearchBoxWithTitle = (props: MemberAdvancedSearchBoxWithTitleProps) => {
  const { title, children, noGrid = false } = props;

  const content = (
    <Box
      sx={{
        p: 2,
        backgroundColor: (thm) => thm.palette.background.default,
        borderRadius: 1,
        border: `1px solid rgba(0,0,0,0.05)`,
      }}
    >
      <Box sx={{ mt: -3.5, pb: 2 }}>
        <Typography
          sx={{ fontWeight: 500, px: 0.5, backgroundColor: '#fff', lineHeight: 1, borderRadius: 1, textTransform: 'uppercase' }}
          component='span'
          variant='subtitle2'
        >
          {title}
        </Typography>
      </Box>
      {noGrid && children}
      {!noGrid && (
        <Grid container spacing={2}>
          {children}
        </Grid>
      )}
    </Box>
  );

  // Conditionally render Grid if noGrid is not true
  if (noGrid) {
    return content; // Just return the Box with children if noGrid is true
  }

  return (
    <Grid item xs={12}>
      {content} {/* Wrap content with Grid if noGrid is false */}
    </Grid>
  );
};
